<template>
    <div data-testid="freelancer-signup-multiple-phases">
        <div data-testid="freelancer-signup-multiple-phase-1">
            <slot name="freelancer-signup-multiple-phase-1" />
        </div>
        <Transition name="freelancer-signup-multiple-phases-fade" mode="out-in">
            <div v-if="isVisiblePhase2" ref="refPhase2" data-testid="freelancer-signup-multiple-phase-2">
                <slot name="freelancer-signup-multiple-phase-2" />
            </div>
        </Transition>
    </div>
</template>
<script setup lang="ts">
    import {toRef, watch, useTemplateRef} from 'vue';
    import {useScrollToElement} from '~/composables/ui/useScrollToElement';

    type FreelancerSignupMultiplePhasesProps = {
        isVisiblePhase2: boolean;
    };
    const props = defineProps<FreelancerSignupMultiplePhasesProps>();

    // Composables
    const {scrollTo} = useScrollToElement();

    // Refs
    const refPhase2 = useTemplateRef('refPhase2');
    const isVisiblePhase2 = toRef(props, 'isVisiblePhase2');

    // Watchers
    watch(isVisiblePhase2, () => {
        if (isVisiblePhase2.value === true) {
            setTimeout(() => {
                if (refPhase2.value) {
                    scrollTo(refPhase2.value);
                }
            }, 400);
        }
    });
</script>
<style lang="scss">
    .freelancer-signup-multiple-phases {
        &-fade-enter-active,
        &-fade-leave-active {
            transition: opacity 0.5s ease;
        }

        &-fade-enter-from,
        &-fade-leave-to {
            opacity: 0;
        }
    }
</style>
